<template>
  <div
    :class="['card vulnerability-severity', vulnerability.severity]"
  >
    <div class="card-body">
      <h4 class="severity-title">{{ vulnerability.severity }} Severity</h4>

      <h1 class="card-title">
        <i class="fal fa-shield-alt fa-fw fa-lg"></i>
        {{ vulnerability.summary }}
      </h1>

      <a
        class="btn btn-sm btn-link px-0 mb-4"
        :href="vulnerability.permalink"
        target="_blank"
      >
        <i class="far fa-external-link-alt fa-fw"></i>
        GitHub Security Advisory Database
      </a>

      <div class="row">
        <div class="col-12 col-lg-8">
          <p>
            <span class="data-label">Vulernerable package</span>
            <span class="d-flex align-items-center">
              <i
                class="fab fa-fw fa-lg text-primary me-2"
                :class="{
                  'fa-php': vulnerability.package_platform === 'packagist',
                  'fa-npm': vulnerability.package_platform === 'npm',
                }"
              />

              <a class="btn btn-link px-0" v-if="vulnerability.package_repository_url" :href="vulnerability.package_repository_url" target="_blank">
                {{ vulnerability.package }} <i class="far fa-external-link-alt fa-fw fa-sm"></i>
              </a>
              <template v-else>
                {{ vulnerability.package }}
              </template>
            </span>
          </p>
        </div>
        <div class="col-6 col-lg-4">
          <p>
            <span class="data-label"><abbr title="GitHub Security Advisory">GHSA</abbr> ID</span>
            {{ vulnerability.ghsa_id }}
          </p>
        </div>
        <div class="col-6 col-lg-4">
          <p>
            <span class="data-label">Date published</span>
            {{ vulnerability.published_at }}
          </p>
        </div>
        <div class="col-6 col-lg-4">
          <p>
            <span class="data-label">Affected versions</span>
            <span
              class="d-block"
              v-for="version in vulnerability.affected_version_ranges"
              :key="version"
              >{{ version }}</span
            >
          </p>
        </div>
        <div class="col-6 col-lg-4">
          <p>
            <span class="data-label">Patched versions</span>
            <span
              class="d-block"
              v-for="version in vulnerability.first_patched_versions"
              :key="version"
              >{{ version }}</span
            >
          </p>
        </div>
      </div>

      <h5>Description</h5>

      <p v-html="description"></p>

      <h5>Remediation</h5>

      <p class="mb-0">Upgrade {{ vulnerability.package }} from {{ vulnerability.dependency_version_installed }} to {{ vulnerability.first_patched_version }}</p>
    </div>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  props: {
    vulnerability: Object
  },

  computed: {
    description () {
      return marked(this.vulnerability.description)
    }
  }
}
</script>
